import * as yup from 'yup';
import { validateRut } from '@wareclouds/frontend-common/b2c';

export const initialValues = {
  rut: '',
  bank: null,
  accountType: null,
  accountNumber: '',
};

export const createBankAccountSchema = (t) => {
  return yup.object().shape({
    rut: yup
      .string()
      .required(t('validation:bank_info.rut.required'))
      .test('is-valid-rut', t('validation:bank_info.rut.invalid'), (rut) => {
        const cleanRut = rut.replace(/[.\s]/g, '');
        return validateRut(cleanRut);
      }),

    bank: yup
      .object()
      .nullable()
      .required(t('validation:bank_info.bank.required'))
      .test('has-label', t('validation:bank_info.bank.invalid'), (value) => {
        return value && value.label && value.label.trim() !== '';
      }),

    accountType: yup
      .object()
      .nullable()
      .required(t('validation:bank_info.account_type.required'))
      .test(
        'has-label',
        t('validation:bank_info.account_type.invalid'),
        (value) => {
          return value && value.label && value.label.trim() !== '';
        }
      ),

    accountNumber: yup
      .string()
      .required(t('validation:bank_info.account_number.required'))
      .min(7, ({ min }) =>
        t('validation:bank_info.account_number.min_length', { min })
      )
      .max(20, ({ max }) =>
        t('validation:bank_info.account_number.max_length', { max })
      )
      .matches(/^\d+$/, t('validation:bank_info.account_number.format')),
  });
};
